import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-activation-card-help',
  templateUrl: './activation-card-help.component.html',
  styleUrls: ['./activation-card-help.component.scss']
})
export class ActivationCardHelpComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  goToHome(){
    this.router.navigate(['/account/balance']);
  }

}
